<template>
  <div id="app" class="app">
    <Header :user="user" />

    <Topic :user="user" :loaded-view="loadedView" />

    <Ranking :user="user" :loaded-view="loadedView" />

    <Reward :loaded-view="loadedView" />

    <Rules :loaded-view="loadedView" />

    <parsing ref="parsing" :loaded-view="loadedView" />

    <News v-if="false" :loaded-view="loadedView" />

    <Aside :current-view="currentView" />

    <Signup :user="user" />

    <a class="mb-contact" target="_blank" href="https://crm2.qq.com/page/portalpage/wpa.php?uin=800185710&cref=https%3A%2F%2Fid.b.qq.com%2Fcrm%2Findex.php%3Frr%3Dwpa&ref=https%3A%2F%2Fid.b.qq.com%2Fcrm%2Findex.php%3Frr%3Dwpa%2Fstyle%26id%3Dwpa_setting_a01&pt=undefined&f=1&ty=1&ap=&as=&aty=0&a="></a>

    <Footer />
  </div>
</template>

<script>
import { throttle } from "throttle-debounce"
import device from "@jin10/utils/lib/device";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Topic from "../../components/Topic";
import Ranking from "../../components/Ranking";
import Reward from "../../components/Reward";
import Rules from "../../components/Rules";
import Parsing from "../../components/Parsing";
import News from "../../components/News";
import Aside from "../../components/Aside";
import Signup from "../../components/Signup";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Signup,
    Topic,
    Ranking,
    Reward,
    Rules,
    Parsing,
    News,
    Aside
  },
  data() {
    return {
      user: null,
      loadedView: [],
      currentView: ''
    };
  },
  mounted() {
    const jsBridge = new Jin10JSBridge();

    jsBridge.getUserInfo().then(res => {
      this.user = res;
    });

    this.initLogin();

    this.$bus.$on("showLogin", (cb) => {
      // uc浏览器视频层级兼容
      if (navigator.userAgent.indexOf("UCBrowser") > -1 || navigator.userAgent.indexOf('HeyTapBrowser') > -1) {
        if (this.$refs.parsing && this.$refs.parsing.playing) {
          document.querySelector('.app-parsing-main-container__video').style.display = 'none'
          document.querySelector('.app-parsing-main-container__video').style.height = '0px'
          document.querySelector('.app-parsing-main-container__video').style.overflow = 'hidden'
        }
      }

      this.userCenterUI.on("login");
      this.cb = cb
    });

    this.$bus.$on("logout", () => {
      this.userCenterUI.on("logout")
    })

    if (device.isMobile) {
      document.querySelector('#jin10_modal_mask').addEventListener('click', (e) => {
        const className = e.target.className
        if (className.indexOf('icon-chuyidong') > -1 || className.indexOf('modal-list') > -1 || className.indexOf('modal-close') > -1) {
          this.resetVideoContent()
        }
      })
    }

    this.onScroll = throttle(500, () => {
      const ids = ["topic", "ranking", "reward", "rules", "parsing", "news"]
      const idsHeight = ids.map(item => ({
        gap: Math.abs(document.querySelector('#' + item) ? document.querySelector('#' + item).getBoundingClientRect().top : 10000),
        id: item
      }))

      idsHeight.sort((a, b) => a.gap - b.gap)

      if (this.loadedView.indexOf(idsHeight[0].id) === -1) {
        this.loadedView.push(idsHeight[0].id)
      }

      if (this.loadedView.indexOf(idsHeight[1].id) === -1) {
        this.loadedView.push(idsHeight[1].id)
      }

      this.currentView = idsHeight[0].id
    })

    this.onScroll()
    document.addEventListener('scroll', this.onScroll)
  },
  methods: {
    initLogin() {
      this.userCenterUI = new Jin10Login({
        showVIP: "vip",
        clickOut: true,
        isApp: false,
        loginCallback: res => {
          console.log("login", res.data);
          this.loginCallback(res.data)
        },
        oauthCallback: res => {
          console.log("oath", res.data);
          this.loginCallback(res.data)
        },

      });
    },
    loginCallback(data) {
      this.user = data;
      this.userCenterUI.close();
      this.resetVideoContent();

      if (typeof this.cb === 'function') {
        this.$nextTick(() => {
          this.cb.call(this)
        })
      }
    },
    // uc浏览器视频层级兼容
    resetVideoContent() {
      if (navigator.userAgent.indexOf("UCBrowser") > -1 || navigator.userAgent.indexOf('HeyTapBrowser') > -1) {
        if (this.$refs.parsing && this.$refs.parsing.playing) {
          document.querySelector('.app-parsing-main-container__video').style.display = 'block'
          document.querySelector('.app-parsing-main-container__video').style.height = ''
          document.querySelector('.app-parsing-main-container__video').style.overflow = ''
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/mixin.scss";

body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  vertical-align: middle;
  background-color: #0e0917;
  font-family: PingFang SC, Helvetica Neue, Helvetica, Hiragino Sans GB,
    Microsoft YaHei, Arial, sans-serif;
}

a {
  text-decoration: none;

  &:hover,
  &:active {
    outline: none;
  }
}

#app {
  position: relative;
  overflow: hidden;

  .mb-contact {
    display: none;
  }
}

@include mobile {
  #app {
    .mb-contact {
      display: block;
      position: fixed;
      right: 0;
      bottom: 0;
      width: percentage(49px / 414px);
      padding-top: percentage(49px / 414px);
      margin-right: percentage(14px / 414px);
      margin-bottom: percentage(103px / 414px);
      background: url(../../assets/contact.png) center/contain no-repeat;
    }
  }
}
</style>
